export default "__VITE_ASSET__BzwTLz8q__"